import { Route } from "react-router-dom";
import CreateSubmittal, { CreateSubmittalFromProject, EditSubmittal } from "../Submittals/Submittal";
import { SubmittalList, UsersSubmittalList } from "../Submittals/Table/SubmittalList";

export const SUBMITTAL_ROUTES = [
    <Route key="submittals" path="/submittals" element={<SubmittalList />} />,
    <Route key="submittals-create" path="/submittals/create_submittal" element={<CreateSubmittal />} />,
    <Route key="submittals-update" path="/submittals/update_submittal/:id" element={<EditSubmittal />} />,
    <Route key="submittals-create-from-project" path="/submittals/create_submittal_from_project/:id" element={<CreateSubmittalFromProject />} />,
    <Route key="submittals-personal" path="/submittals/personal" element={<UsersSubmittalList />} />
];
